import { type WallType } from '@cx-sdk/cvms';

import { type RepubConfig } from '@cx-modules/constants';

import { type ComponentTag } from '~/constants/component-tags';
import { type WithContext } from '~/interfaces/WithContext';
import { type Wallable } from '~/traits/Wallable';
import { type Environment } from '~/types/Environment';
import { type FeatureFlag } from '~/types/FeatureFlag';
import { type RequestContext } from '~/types/RequestContext';
import { type RequestUserContext } from '~/types/RequestUserContext';

export abstract class ComponentConfiguration implements Wallable, WithContext {
	abstract get tag(): ComponentTag;
	abstract set tag(tag: ComponentTag);

	environment: Environment;
	featureFlags: FeatureFlag[];
	repubConfig: RepubConfig;
	user: RequestUserContext;

	constructor(requestContext: RequestContext) {
		const { environment, featureFlags, repubConfig, user } = requestContext;
		this.environment = environment;
		this.featureFlags = featureFlags;
		this.repubConfig = repubConfig;
		this.user = user;
	}

	get isWalled(): boolean {
		return this.wallType !== undefined;
	}

	get wallType(): WallType | undefined {
		return this.user.walls.find(wall => wall.componentTag === this.tag)?.type;
	}
}
